import { sortBy } from 'lodash'
import API from 'src/util/api'

import config from './config'
import { getFileUrl } from 'src/component/CourseDetail/Practice/Util'

export const ExcerciseTypes = {
  LISTEN_WITH_IMAGE: 'LISTEN WITH IMAGE',
  LISTEN_WITH_AUDIO: 'LISTEN WITH AUDIO',
  LISTEN_WITH_TEXT: 'LISTEN WITH TEXT',
  LISTEN_WITH_ORDER: 'LISTEN WITH ORDER',
  LISTEN_WITH_TYPE: 'LISTEN WITH TYPE',
  LISTEN_WITH_RECORD: 'LISTEN WITH RECORD',
  WATCH_WITH_AUDIO: 'WATCH WITH AUDIO',
  WATCH_WITH_TEXT: 'WATCH WITH TEXT',
  WATCH_WITH_ORDER: 'WATCH WITH ORDER',
  WATCH_WITH_TYPE: 'WATCH WITH TYPE',
  WATCH_WITH_RECORD: 'WATCH WITH RECORD',
  WATCH_VIDEO: 'WATCH VIDEO',
  WATCH_4LVIDEO: 'WATCH 4LVIDEO',
}

export const LOADING_ERROR = asset =>
  `Error during loading ${asset}, Please try again.`
export const ADD_ERROR = asset =>
  `Error during adding/updating ${asset}, Please try again.`
export const DELETE_ERROR = asset =>
  `Error during deleting ${asset}, Please try again.`

export const filterByKeyValue = (list = [], key, value) => {
  if (list && key && value) {
    return list.filter(item => item[key]?.id === value)
  }
  return list
}

export const extractMediaOptions = options => {
  let optionList = []

  if (options) {
    for (let item of Object.entries(options)) {
      if (item[0].includes('option') && item[0].includes('File')) {
        optionList.push({ key: item[0], value: item[1] })
      }
    }
  }
  return optionList
}

export const extractOptions = options => {
  if (options) {
    let onlyOptions = Object.keys(options).filter(
      optionKey =>
        optionKey.includes('option') &&
        !optionKey.includes('File') &&
        !optionKey.includes('optiontype')
    )

    if (onlyOptions.length === 0) {
      onlyOptions = Object.keys(options).filter(
        optionKey =>
          optionKey.includes('option') &&
          optionKey.includes('File') &&
          !optionKey.includes('optiontype')
      )
    }

    return onlyOptions.reduce((result, optionKey) => {
      const nativeOptionKey = `native${optionKey[0].toUpperCase() + optionKey.substring(1)
        }`
      const optionFileKey = `${optionKey}File`
      const nativeValue = options[nativeOptionKey]
      const nativeFile = options[optionFileKey]

      return [
        ...result,
        {
          key: optionKey,
          value: options[optionKey],
          nativeValue,
          nativeFile,
        },
      ]
    }, [])
  }
  return []
}

export const checkAnswer = (selectedOption, selectedExercise) => {
  if (selectedExercise.questionType === ExcerciseTypes.LISTEN_WITH_TYPE || selectedExercise.questionType === ExcerciseTypes.WATCH_WITH_TYPE) {
    const validAnswers = selectedExercise.options.answer
      .split(',')
      .map(val => val.trim())

    return validAnswers.includes(selectedOption)
  }
  return typeof selectedOption === 'object'
    ? selectedOption?.key?.includes(selectedExercise.options.answer.trim())
    : selectedExercise.options.hasOwnProperty('option1')
      ? selectedExercise.options.answer?.trim() === selectedOption
      : selectedExercise.options.answer?.includes(selectedOption)
        ? true
        : false
}

export const sortedByOrder = (data) =>
  data.sort((firstEl, secondEl) => {
    const firstSortOrder = firstEl?.sortOrder ?? Infinity;
    const secondSortOrder = secondEl?.sortOrder ?? Infinity;

    if (firstSortOrder === 0 && secondSortOrder !== 0) return 1;
    if (secondSortOrder === 0 && firstSortOrder !== 0) return -1;

    return firstSortOrder - secondSortOrder;
  });

const customSort = (data) => sortedByOrder(sortBy(data, 'name'));

export const sortChapterAndLessons = (chapters) =>
  customSort(chapters).map((chapter) => {
    const sortedLessons = chapter?.lessons?.length ? customSort(chapter.lessons) : [];

    return {
      ...chapter,
      lessons: sortedLessons,
    };
  });


export const downloadFile = async (file) => {
  const zipUrl = `${config.API_URI}download/${file}`;

  try {
    const response = await API.get(zipUrl);

    // Convert the response to a Blob (binary large object)
    // const blob = await response.blob();  // Ensure response is treated as a binary blob

    // Create a link element to simulate a download
    const url = window.URL.createObjectURL(response);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file);  // Specify the file name

    // Trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up the DOM element and revoke object URL
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}

const EMAIL_REGEX = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i

export const isValidEmail = email => {
  return email && EMAIL_REGEX.test(email)
}

export const toSeconds = ms => {
  if(typeof(ms) !== 'number') {
    const hms = ms.split(',')[0];
    const [hours, minutes, seconds] = hms.split(':')
    const totalSeconds = +hours * 60 * 60 + +minutes * 60 + +seconds
    return totalSeconds;
  }
  
  return (ms / 1000).toFixed(3);
}
export const getCourseCreatorName = auth => {
  return 'Anil Mahato'
}

export const carouselRightBtnClick = e => {
  let carousel = e.currentTarget.parentElement
  const slides = carousel.querySelector('div')
  let scrollWidth = parseInt(getComputedStyle(slides).width, 10)
  carousel.scrollTo({
    top: 0,
    left: carousel.scrollLeft - scrollWidth,
    behavior: 'smooth',
  })
}
export const carouselLeftBtnClick = e => {
  let carousel = e.currentTarget.parentElement
  const slides = carousel.querySelector('div')
  let scrollWidth = parseInt(getComputedStyle(slides).width, 10)
  carousel.scrollTo({
    top: 0,
    left: carousel.scrollLeft + scrollWidth,
    behavior: 'smooth',
  })
}

export function videoScroll() {
  if (document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight,
      videoEl = document.querySelectorAll('video[autoplay]')

    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
        videoHeight = thisVideoEl.clientHeight,
        videoClientRect = thisVideoEl.getBoundingClientRect().top

      if (
        videoClientRect <= windowHeight - videoHeight * 0.5 &&
        videoClientRect >= 0 - videoHeight * 0.5
      ) {
        thisVideoEl.play()
      } else {
        thisVideoEl.pause()
      }
    }
  }
}

/**
   * checks if user has already subscribed for the plan.
   * @param {string} plan 
   * @param {object} subscriptionData 
   * @returns {boolean}
   */

export function isPlanTaken(plan, subscriptionData) {
  const plans = subscriptionData?.map((subscription) => subscription.plan.id)
  return plans ? plans.includes(plan.id) : false;
}

export function capitalizeFirstLetter(str) {
  if (!str) return str; // Handle empty string or null case
  return str.charAt(0).toUpperCase() + str.slice(1);
}


export function getYouTubeThumbnailUrl(url) {
  // Validate if URL is valid and is a YouTube URL
  try {
    const urlObj = new URL(url);
    if (!urlObj.hostname.includes('youtube.com') && !urlObj.hostname.includes('youtu.be')) {
      return false;
    }
  } catch (error) {
    return 'https://bit.ly/2Z4KKcF'
  }

  const urlParams = new URL(url).searchParams;
  let videoId;

  if (urlParams.has('v')) {
    videoId = urlParams.get('v');
  } else {
    const urlPath = new URL(url).pathname;
    videoId = urlPath.split('/').pop();
    if (videoId.includes('?')) {
      videoId = videoId.split('?')[0];
    }
    if (url.includes('youtu.be')) {
      videoId = urlPath.split('/').pop();
    } else if (url.includes('youtube.com/playlist') || url.includes('youtube.com/watch')) {
      const regex = /(?:v|embed|shorts)\/([^"&?\/\s]{11})/gi;
      const match = regex.exec(url);
      if (match && match[1]) {
        videoId = match[1];
      }
    }
  }

  if (!videoId) {
    return false;
  }

  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}


export const thumbnailRenderer = (crs) => {
  if (crs?.videoThumbnail) {
    return getFileUrl(crs.videoThumbnail)
  }
  else if (crs?.videoUrl || crs.video) {
    return getYouTubeThumbnailUrl(crs.video || crs.videoUrl)
  }
   
  else return 'https://bit.ly/2Z4KKcF'
}